module.exports = __webpack_public_path__ + "img/inge-v6-2.0bae380d.png";